var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoToyota(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 250,
    height: 120,
    viewBox: "0 65 250 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M69.058 124.998c0 19.3 25.096 35.002 55.943 35.002 30.845 0 55.94-15.702 55.94-35.002 0-19.301-25.096-34.998-55.94-34.998-30.846 0-55.943 15.696-55.943 34.998zm1.718 0c0-18.353 24.324-33.283 54.225-33.283s54.224 14.931 54.224 33.283c0 18.35-24.326 33.285-54.224 33.285-29.9 0-54.225-14.929-54.225-33.285z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M119.713 96.357c-13.092.801-22.602 4.271-24.223 8.842-.165.462-.25.947-.25 1.437.008.804.232 1.591.65 2.278 1.818 3.096 7.458 5.65 15.485 7.019l.851.139.142-.848c1.317-8.037 4.21-14.357 7.938-17.342l2.112-1.691-2.705.166zM97.371 108.05a2.766 2.766 0 0 1-.417-1.404c0-.295.053-.588.155-.866 1.237-3.492 9.638-6.543 20.378-7.526-3.063 3.461-5.417 9.047-6.644 15.83-6.979-1.297-11.996-3.521-13.472-6.034z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m117.32 115.733-.167.937.946.071c2.246.167 4.569.259 6.898.259 2.33 0 4.656-.095 6.9-.259l.947-.071-.168-.937c-1.291-7.252-4.164-11.583-7.673-11.583-3.506 0-6.392 4.334-7.683 11.583zm7.681-9.862c2.401 0 4.62 3.597 5.788 9.213-1.9.124-3.838.201-5.791.201a88.76 88.76 0 0 1-5.786-.201c1.165-5.62 3.386-9.213 5.789-9.213z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M129.693 97.884c3.727 2.984 6.623 9.305 7.941 17.341l.141.849.846-.14c8.031-1.369 13.674-3.924 15.482-7.019a4.296 4.296 0 0 0 .406-3.714c-1.621-4.572-11.131-8.043-24.225-8.843l-2.697-.167 2.106 1.693zm2.821.364c10.736.982 19.143 4.039 20.375 7.527.104.276.156.57.156.867-.01.495-.154.979-.414 1.403-1.479 2.514-6.498 4.736-13.475 6.027-1.226-6.777-3.582-12.359-6.642-15.824zM87.206 108.569c-5.884 4.93-8.994 10.785-8.994 16.938 0 14.472 17.647 26.703 41.047 28.447l2.613.195-1.989-1.698c-5.128-4.386-8.311-14.793-8.311-27.158l.054-2.922-.718-.146c-12.308-2.206-21.063-7.383-22.31-13.179l-.298-1.392-1.094.915zm-7.276 16.939c0-5.276 2.574-10.34 7.405-14.736 2.251 5.854 10.663 10.733 22.553 13.007-.014.669-.027 1.52-.027 1.52 0 11.466 2.721 21.366 7.206 26.711-21.322-2.281-37.137-13.418-37.137-26.502z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M118.345 124.88c.125 10.694 3.495 17.843 6.656 17.843 3.159 0 6.524-7.148 6.655-17.843-2.186.16-4.412.262-6.655.262-2.246 0-4.474-.102-6.656-.262z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m133.371 123.033-.922.077a85.74 85.74 0 0 1-7.448.32c-2.514 0-5.022-.107-7.446-.32l-.926-.083-.008.937v.312c0 11.493 3.604 20.167 8.384 20.167s8.382-8.674 8.382-20.167l-.016-1.243zm-8.37 19.69c-3.161 0-6.53-7.148-6.656-17.843 2.182.16 4.412.262 6.656.262 2.243 0 4.47-.102 6.655-.262-.131 10.692-3.5 17.843-6.655 17.843z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M161.402 109.048c-1.244 5.796-10.002 10.973-22.309 13.177l-.721.135.057 2.933c0 12.367-3.18 22.772-8.309 27.158l-1.99 1.7 2.611-.197c23.398-1.742 41.049-13.976 41.049-28.447 0-6.151-3.113-12.007-8.996-16.938l-1.092-.912-.3 1.391zm1.262 1.723c4.834 4.397 7.41 9.46 7.41 14.735 0 13.086-15.814 24.223-37.137 26.498 4.486-5.344 7.207-15.246 7.207-26.712 0 0-.02-.849-.029-1.519 11.885-2.27 20.295-7.147 22.545-12.999l.004-.003z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -203.98,
    x2: -203.98,
    y1: -98.385,
    y2: -59.48,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#b2b3b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    style: {
      stopColor: "#cacbcc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    style: {
      stopColor: "#dcdedf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    style: {
      stopColor: "#e9ebed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    style: {
      stopColor: "#f1f3f5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M162.008 104.629a6.52 6.52 0 0 1 .045 4.442c5.584 4.604 8.873 10.283 8.873 16.437 0 15.353-20.563 27.803-45.925 27.803-25.363 0-45.927-12.444-45.927-27.803 0-6.15 3.294-11.833 8.871-16.437a6.57 6.57 0 0 1-.16-3.777c.067-.244.157-.482.267-.709-7.618 5.427-12.237 12.539-12.237 20.329 0 17.009 22.02 30.795 49.186 30.795 27.167 0 49.185-13.786 49.185-30.795 0-7.776-4.6-14.869-12.178-20.285z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D9DD",
    d: "M131.832 115.889c-2.17.162-4.451.251-6.831.251s-4.665-.089-6.832-.251h-.007l-1.417 1.029a95.595 95.595 0 0 0 16.516 0l-1.429-1.029z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -203.98,
    x2: -203.98,
    y1: -67.729,
    y2: -47.437,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M156.955 105.1c-1.725-5.71-15.957-9.897-31.954-9.897-15.998 0-30.227 4.189-31.954 9.897-1.498 4.95 6.682 9.532 19.588 11.35l-1.122-1.365c-10.441-1.778-16.648-5.565-15.215-9.595 1.735-4.891 14.338-8.433 28.699-8.433 14.362 0 26.97 3.542 28.7 8.433 1.432 4.023-4.771 7.817-15.215 9.595l-1.117 1.365c12.903-1.818 21.086-6.4 19.59-11.35z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#44484C",
    d: "M162.059 109.071a28.458 28.458 0 0 1 5.334 5.727 19.706 19.706 0 0 0-3.756-8.937 39.546 39.546 0 0 0-1.633-1.229 6.56 6.56 0 0 1 .055 4.439zM87.943 109.071a6.58 6.58 0 0 1-.16-3.777c.067-.244.157-.482.268-.709-.582.417-1.145.842-1.693 1.273a19.777 19.777 0 0 0-3.749 8.939 28.42 28.42 0 0 1 5.334-5.726z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -203.981,
    x2: -203.981,
    y1: -37.335,
    y2: -105.62,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#f0f3f5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    style: {
      stopColor: "#e8eaec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    style: {
      stopColor: "#dadcdf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c5c9cb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#abafb1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    style: {
      stopColor: "#8b9092"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    style: {
      stopColor: "#656b6e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#53595c"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M69.918 124.998c0-18.854 24.659-34.144 55.083-34.144 30.423 0 55.079 15.289 55.079 34.144 0 18.852-24.66 34.141-55.079 34.141-30.42 0-55.083-15.282-55.083-34.141zm55.083 30.711c27.161 0 49.185-13.786 49.185-30.795s-22.023-30.797-49.185-30.797c-27.163 0-49.188 13.788-49.188 30.797s22.021 30.795 49.188 30.795z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#555656",
    d: "m116.315 121.874.01.006 1.181 2.084c2.407.206 4.907.322 7.496.322 2.587 0 5.106-.116 7.526-.328l1.15-2.078.006-.006a92.106 92.106 0 0 1-8.683.408c-3.019 0-5.92-.146-8.686-.408z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -178.857,
    x2: -178.857,
    y1: -51.654,
    y2: -69.729,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M162.41 107.218c-.295 6.378-10.098 12.028-24.584 14.157v.004l1.412 1.686c14.18-2.543 23.506-8.804 23.172-15.847z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -758.109,
    x2: -758.109,
    y1: -51.654,
    y2: -69.729,
    gradientTransform: "rotate(180 -329.115 26.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M87.591 107.218c.294 6.378 10.097 12.028 24.584 14.157l-.004.004-1.413 1.686c-14.177-2.543-23.503-8.804-23.167-15.847z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M88.052 104.585a34.09 34.09 0 0 0-7.788 7.721 22.17 22.17 0 0 0-4.044 10.053 19.784 19.784 0 0 0 1.637 10.628 27.104 27.104 0 0 0 6.429 8.712 49.676 49.676 0 0 0 19.048 10.417 76.659 76.659 0 0 0 43.262.021 49.849 49.849 0 0 0 19.066-10.387 27.273 27.273 0 0 0 6.449-8.701 19.734 19.734 0 0 0 1.676-10.62 22.113 22.113 0 0 0-4.008-10.064 33.947 33.947 0 0 0-7.768-7.736 34.075 34.075 0 0 1 7.955 7.604 22.453 22.453 0 0 1 4.273 10.146 20.196 20.196 0 0 1-1.59 10.919 27.884 27.884 0 0 1-6.502 8.982 41.94 41.94 0 0 1-9.051 6.421 58.1 58.1 0 0 1-10.25 4.253 75.591 75.591 0 0 1-43.765-.025 57.927 57.927 0 0 1-10.243-4.264 41.811 41.811 0 0 1-9.043-6.441 27.788 27.788 0 0 1-6.477-9 20.22 20.22 0 0 1-1.549-10.924 22.533 22.533 0 0 1 4.313-10.126 34.155 34.155 0 0 1 7.97-7.589z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -203.982,
    x2: -203.982,
    y1: -37.977,
    y2: -102.19,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    style: {
      stopColor: "#f0f2f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    style: {
      stopColor: "#e7e9ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#d8d9da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    style: {
      stopColor: "#c2c3c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#a6a7a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    style: {
      stopColor: "#9fa09e"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M125.001 91.497c-18.623 0-35.796 8.181-37.216 13.802-1.807 7.14 8.459 13.735 24.396 16.079a69.88 69.88 0 0 0-.122 4.077c0 16.707 5.793 30.254 12.938 30.254 7.147 0 12.94-13.547 12.94-30.254 0-1.382-.045-2.742-.123-4.079 15.936-2.339 26.203-8.938 24.396-16.082-2.007-7.958-18.589-13.797-37.209-13.797zm0 54.922c-4.817 0-8.72-9.482-8.72-21.99 0-.866.021-1.712.054-2.542 2.761.261 5.656.403 8.666.403 3.009 0 5.905-.143 8.667-.403.035.829.053 1.675.053 2.542 0 12.504-3.906 21.984-8.72 21.984v.006zm-8.235-29.497c1.182-8.797 4.417-14.429 8.235-14.429 3.817 0 7.054 5.634 8.235 14.429-2.609.23-5.361.357-8.235.357s-5.626-.131-8.235-.361v.004zm20.582-.468c-1.648-12.228-6.551-21.249-12.353-21.249-5.801 0-10.692 9.019-12.342 21.245-12.914-1.815-21.105-6.399-19.606-11.351 1.727-5.71 15.958-9.897 31.954-9.897 15.993 0 30.226 4.189 31.954 9.897 1.5 4.951-6.688 9.535-19.604 11.351l-.003.004z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -203.981,
    x2: -203.981,
    y1: -37.335,
    y2: -105.62,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53595c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    style: {
      stopColor: "#5d6366",
      stopOpacity: 0.934
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    style: {
      stopColor: "#8c9093",
      stopOpacity: 0.645
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    style: {
      stopColor: "#b2b6b8",
      stopOpacity: 0.406
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#cfd2d4",
      stopOpacity: 0.223
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    style: {
      stopColor: "#e4e6e8",
      stopOpacity: 0.094
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    style: {
      stopColor: "#f0f2f4",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f3f5f7",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M69.918 124.998c0-18.854 24.659-34.144 55.083-34.144 30.423 0 55.079 15.289 55.079 34.144 0 18.852-24.66 34.141-55.079 34.141-30.42 0-55.083-15.282-55.083-34.141zm55.083 30.711c27.161 0 49.185-13.786 49.185-30.795s-22.023-30.797-49.185-30.797c-27.163 0-49.188 13.788-49.188 30.797s22.021 30.795 49.188 30.795z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -196.977,
    x2: -210.14,
    y1: -64.866,
    y2: -53.821,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M118.183 115.888c1.203-6.659 3.799-10.822 6.818-10.822 3.017 0 5.614 4.163 6.817 10.822h.021l1.404 1.018c-1.182-8.796-4.424-14.417-8.24-14.417s-7.06 5.621-8.241 14.417l1.403-1.018h.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -209.098,
    x2: -199.484,
    y1: -56.177,
    y2: -56.177,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686e72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    style: {
      stopColor: "#73787c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "#8f9498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#bdc2c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d4d8dc"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M118.183 115.888c1.203-6.659 3.799-10.822 6.818-10.822 3.017 0 5.614 4.163 6.817 10.822h.021l1.404 1.018c-1.182-8.796-4.424-14.417-8.24-14.417s-7.06 5.621-8.241 14.417l1.403-1.018h.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -195.642,
    x2: -214.833,
    y1: -83.24,
    y2: -72.159,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M116.281 124.416c0 12.517 3.903 21.997 8.72 21.997 4.815 0 8.72-9.48 8.72-21.997 0-.86-.02-1.697-.055-2.527l-1.146 2.073c0 .152.008.307.008.47 0 11.04-3.377 19.412-7.529 19.412s-7.526-8.372-7.526-19.412c0-.176 0-.348.008-.516l-1.148-2.021a59.309 59.309 0 0 0-.052 2.521z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -209.551,
    x2: -195.507,
    y1: -76.561,
    y2: -82.566,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686e72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#d4d8dc"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M116.281 124.416c0 12.517 3.903 21.997 8.72 21.997 4.815 0 8.72-9.48 8.72-21.997 0-.86-.02-1.697-.055-2.527l-1.146 2.073c0 .152.008.307.008.47 0 11.04-3.377 19.412-7.529 19.412s-7.526-8.372-7.526-19.412c0-.176 0-.348.008-.516l-1.148-2.021a59.309 59.309 0 0 0-.052 2.521z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -210.71,
    x2: -210.71,
    y1: -37.332,
    y2: -70.769,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M112.652 116.453c1.65-12.227 6.55-21.251 12.353-21.251-6.211 0-11.504 7.996-13.471 19.905l1.107 1.346h.011z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -210.71,
    x2: -210.71,
    y1: -43.28,
    y2: -61.744,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    style: {
      stopColor: "#d1d5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#c9cdd1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    style: {
      stopColor: "#babec2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    style: {
      stopColor: "#a5a9ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    style: {
      stopColor: "#8a8f93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#696f73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M112.652 116.453c1.65-12.227 6.55-21.251 12.353-21.251-6.211 0-11.504 7.996-13.471 19.905l1.107 1.346h.011z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -197.244,
    x2: -197.244,
    y1: -37.332,
    y2: -70.769,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M137.352 116.453h.012l1.107-1.346c-1.961-11.913-7.264-19.905-13.47-19.905 5.792 0 10.698 9.022 12.351 21.251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -197.244,
    x2: -197.244,
    y1: -43.681,
    y2: -61.94,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    style: {
      stopColor: "#d1d5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#c9cdd1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    style: {
      stopColor: "#babec2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    style: {
      stopColor: "#a5a9ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    style: {
      stopColor: "#8a8f93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#696f73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M137.352 116.453h.012l1.107-1.346c-1.961-11.913-7.264-19.905-13.47-19.905 5.792 0 10.698 9.022 12.351 21.251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -196.835,
    x2: -196.835,
    y1: -37.052,
    y2: -92.856,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M137.83 121.383h-.01c.08 1.336.121 2.693.121 4.072 0 16.707-5.793 30.254-12.938 30.254 8.013 0 14.282-12.564 14.282-30.254 0-.809-.016-1.604-.045-2.392l-1.41-1.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -196.835,
    x2: -196.835,
    y1: -69.348,
    y2: -105.255,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#686e72"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M137.83 121.383h-.01c.08 1.336.121 2.693.121 4.072 0 16.707-5.793 30.254-12.938 30.254 8.013 0 14.282-12.564 14.282-30.254 0-.809-.016-1.604-.045-2.392l-1.41-1.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -211.121,
    x2: -211.121,
    y1: -37.052,
    y2: -92.856,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f3f5f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#eceef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#dee2e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#d6dade"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686e72"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M112.062 125.455c0-1.379.045-2.736.123-4.072h-.01l-1.412 1.675a70.388 70.388 0 0 0-.045 2.397c0 17.688 6.269 30.254 14.285 30.254-7.145 0-12.941-13.547-12.941-30.254z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -211.121,
    x2: -211.121,
    y1: -68.546,
    y2: -100.24,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    style: {
      stopColor: "#d4d8dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    style: {
      stopColor: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#82878b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#686e72"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M112.062 125.455c0-1.379.045-2.736.123-4.072h-.01l-1.412 1.675a70.388 70.388 0 0 0-.045 2.397c0 17.688 6.269 30.254 14.285 30.254-7.145 0-12.941-13.547-12.941-30.254z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoToyota);
export default __webpack_public_path__ + "static/media/logo_toyota.794d017080916193e734a73af880576c.svg";
export { ForwardRef as ReactComponent };